function keepDecimal(num: number, precision = 1) {
	const multiplier = 10 ** precision;
	return Math.floor(num * multiplier) / multiplier;
}

export const formatThousandthsNum = (num = 0, precision = 1) => {
	if (num >= 1000000) {
		return `${keepDecimal(num / 1000000, precision)}M`;
	}

	if (num >= 1000) {
		return `${keepDecimal(num / 1000, precision)}K`;
	}

	return num.toString();
};

export const formatNumber = (num: number, decimals = 1, options: {
	formatAll: boolean;
	zeroReturn: string;
} = {
	formatAll: false,
	zeroReturn: "",
}) => {
	const absNum = Math.abs(num);
	const sign = num < 0 ? "-" : "";

	const formatWithUnit = (value: number, unit: string) => {
		const pointFix = Math.pow(10, decimals);
		const preRes = Number.parseInt((value * pointFix).toString());
		const formatted = Number(preRes) / pointFix;
		let point = "";
		if (Number(preRes) % pointFix === 0) {
			point = ".0";
		}
		return sign + formatted + point + unit;
	};

	if (absNum >= 1000000000) {
		return formatWithUnit(absNum / 1000000000, "B");
	} else if (absNum >= 1000000) {
		return formatWithUnit(absNum / 1000000, "M");
	} else if (absNum >= 1000) {
		return formatWithUnit(absNum / 1000, "K");
	} else if (options.formatAll) {
		if (absNum === 0 && options.zeroReturn) {
			return options.zeroReturn;
		}
		return formatWithUnit(absNum, "");
	} else {
		return num.toString();
	}
};



/**
 * 格式化数字，保留指定位数的数字，并返回整数部分、零个数和有效数字部分
 */
export function formatNumberWithZeroCount({numStr, decimals, minZeroCount = 2}:{numStr?: string, decimals: number, minZeroCount: number}): { integerPart: string, zeroCount: number, leftDigits: string, isSuccess: boolean } {
    if(!numStr){
        return { integerPart: '', zeroCount: 0, leftDigits: '', isSuccess: false };
    }
    // 将数字转换为字符串并分割整数和小数部分
    const [integerPart, decimalPart] = numStr.split('.');
  
    // 如果没有小数部分，则直接返回整数部分和零个数为0的结果
    if (!decimalPart) {
        return { integerPart, zeroCount: 0, leftDigits: ''.padEnd(decimals, '0'), isSuccess: true };
    }
  
    // 计算有效数字
    let leftDigits = '';
    let zeroCount = 0;
    let tempZeroCount = 0;
    let tempZeros = '';
    let foundNonZero = false;
  
    // 如果连续的0超过阈值，记录到zeroCount，否则保留在结果中
    for (let i = 0; i < decimalPart.length; i++) {
        const digit = decimalPart[i];
        
        if (!foundNonZero) {
            if (digit === '0') {
                tempZeroCount++;
                tempZeros += '0';
            } else {
                foundNonZero = true;
                if (tempZeroCount >= minZeroCount) {
                    zeroCount = tempZeroCount;
                    leftDigits += digit;
                } else {
                    leftDigits += tempZeros + digit;
                }
                tempZeros = '';
            }
        } else {
            leftDigits += digit;
        }
    }

    // 处理全是0的情况
    if (!foundNonZero) {
        if (tempZeroCount >= minZeroCount) {
            zeroCount = tempZeroCount;
            leftDigits = '';
        } else {
            leftDigits = tempZeros;
        }
    }

    // 如果 zeroCount 为 0，返回小数点后指定的 decimals 位，并补0
    if (zeroCount === 0) {
        leftDigits = (decimalPart + '0'.repeat(decimals)).slice(0, decimals);
    } else {
        // 如果有 zeroCount，只截取非零部分，不补0
        leftDigits = leftDigits.slice(0, decimals);
    }
    if(leftDigits?.length > 0 && Number(leftDigits) === 0){
        return { integerPart, zeroCount: 0, leftDigits: '0', isSuccess: true };
    }
    return { integerPart, zeroCount, leftDigits, isSuccess: true };
}

/**
 * 获取左边的数字
 * @param priceData 价格数据
 * @returns 左边的数字
 */
export const getLeftDigits = (priceData: { integerPart: string; zeroCount: number; leftDigits: string; isSuccess: boolean }) => {
if (!priceData?.isSuccess) {
    return priceData?.leftDigits;
}

const integerPart = Number(priceData.integerPart);
if (integerPart > 0 && priceData?.leftDigits?.length > 2) {
    return priceData.leftDigits?.substring(0, 2);
} else if (integerPart === 0 && priceData?.leftDigits?.length > 6) {
    return Number(priceData.leftDigits?.substring(0, 6) || 0) !== 0
    ? priceData.leftDigits?.substring(0, 6)
    : null;
}
return priceData?.leftDigits;
}